var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoundTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 118,
    viewBox: "0 0 118 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.9584,
    y: 1.9584,
    width: 114.083,
    height: 114.083,
    rx: 57.0416,
    fill: "#DAF8D7",
    stroke: "#50AF47",
    strokeWidth: 3.91681
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.7051 61.4794L52.058 78.8323L86.7639 41.6475",
    stroke: "#50AF47",
    strokeWidth: 6.94118,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundTick);
export default __webpack_public_path__ + "static/media/RoundTick.68b617a9c83e50ac705032bf8628d5c6.svg";
export { ForwardRef as ReactComponent };